import { RATING_THRESHOLDS } from "@/pages/CreatorAnalytics/constants";
import type { ICharacterPerformance } from "@/pages/CreatorAnalytics/types";

import { escapeCsvField } from "./escapeCsvField";
import { toLocalDateStr } from "./toLocalDateStr";

const CSV_HEADER = "Name,NSFW,Requests,Users,Conversations,Avg Depth,Rating,Ratings Count,Likes,Unlikes,Net Likes,Tags";
const CSV_MIME_TYPE = "text/csv;charset=utf-8;";
const CSV_FILENAME_PREFIX = "creator-analytics-";

const toCsvRow = (character: ICharacterPerformance): string => {
  const rating = character.avgRating !== null ? (character.avgRating * RATING_THRESHOLDS.PERCENTAGE_MULTIPLIER).toFixed(1) : "";
  const tags = escapeCsvField(character.tags.join(", "));
  return [
    escapeCsvField(character.name),
    character.isNsfw,
    character.totalRequests,
    character.uniqueUsers,
    character.uniqueConversations,
    character.avgDepth.toFixed(1),
    rating,
    character.ratingsCount,
    character.likes,
    character.unlikes,
    character.netLikes,
    tags,
  ].join(",");
};

export const buildCharactersCsv = (characters: ICharacterPerformance[]): string => {
  const rows = characters.map(toCsvRow);
  return [CSV_HEADER, ...rows].join("\n");
};

export const exportCharactersCsv = (characters: ICharacterPerformance[]): void => {
  const csv = buildCharactersCsv(characters);
  const blob = new Blob([csv], { type: CSV_MIME_TYPE });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${CSV_FILENAME_PREFIX}${toLocalDateStr(new Date())}.csv`;
  link.click();
  URL.revokeObjectURL(url);
};
